import { GlCollapsibleListbox } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import groupProjectsQuery from '../graphql/group_projects.query.graphql';
import { setError } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/boards/graphql/cache_updates.js?vue3';
export default {
    name: 'ProjectSelect',
    i18n: {
        headerTitle: s__(`BoardNewIssue|Projects`),
        dropdownText: s__(`BoardNewIssue|Select a project`),
        searchPlaceholder: s__(`BoardNewIssue|Search projects`),
        emptySearchResult: s__(`BoardNewIssue|No matching results`),
        errorFetchingProjects: s__('Boards|An error occurred while fetching group projects. Please try again.')
    },
    defaultFetchOptions: {
        with_issues_enabled: true,
        with_shared: false,
        include_subgroups: true,
        order_by: 'similarity'
    },
    components: {
        GlCollapsibleListbox
    },
    inject: [
        'fullPath'
    ],
    model: {
        prop: 'selectedProject',
        event: 'select-project'
    },
    props: {
        selectedProject: {
            type: Object,
            required: true
        }
    },
    emits: [
        'select-project'
    ],
    data () {
        return {
            initialLoading: true,
            selectedProjectId: '',
            searchTerm: '',
            projects: {},
            isLoadingMore: false
        };
    },
    apollo: {
        projects: {
            query: groupProjectsQuery,
            variables () {
                return {
                    fullPath: this.fullPath,
                    search: this.searchTerm
                };
            },
            update (data) {
                return data.group.projects;
            },
            error (error) {
                setError({
                    error,
                    message: this.$options.i18n.errorFetchingProjects
                });
            },
            result () {
                this.initialLoading = false;
            }
        }
    },
    computed: {
        isLoading () {
            return this.$apollo.queries.projects.loading && !this.isLoadingMore;
        },
        activeGroupProjects () {
            return this.projects?.nodes?.filter((p)=>!p.archived).map((project)=>({
                    value: project.id,
                    text: project.nameWithNamespace
                })) || [];
        },
        selectedProjectName () {
            return this.selectedProject.name || this.$options.i18n.dropdownText;
        },
        hasNextPage () {
            return this.projects.pageInfo?.hasNextPage;
        }
    },
    watch: {
        endCursor () {
            return this.projects.pageInfo?.endCursor;
        }
    },
    methods: {
        selectProject (projectId) {
            this.selectedProjectId = projectId;
            this.$emit('select-project', this.projects.nodes.find((project)=>project.id === projectId));
        },
        async loadMoreProjects () {
            if (!this.hasNextPage) return;
            this.isLoadingMore = true;
            try {
                await this.$apollo.queries.projects.fetchMore({
                    variables: {
                        fullPath: this.fullPath,
                        search: this.searchTerm,
                        after: this.endCursor
                    }
                });
            } catch (error) {
                setError({
                    error,
                    message: this.$options.i18n.errorFetchingProjects
                });
            } finally{
                this.isLoadingMore = false;
            }
        },
        onSearch (query) {
            this.searchTerm = query;
        }
    }
};
